import { Injectable, inject } from '@angular/core';

import { BetGroupType } from '@bpos';
import { Odds as BPosOdds, BetGroup } from '@bpos/common/bet-placement';
import { Bet, PlaceBetRequest } from '@bpos/v2/bet-placement';
import { Odds, OddsOperations } from '@frontend/sports/odds/feature';
import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { IBetslipState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { ISlip } from '../../../../bet-generation/models';
import { getTeaserSlipId } from '../../../../bet-generation/services/slip.utils';
import { IBetPicks } from '../../../models';
import { RequestStrategy } from './request-strategies';

@Injectable()
export class TeaserBetRequestStrategy implements RequestStrategy {
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);

    isActive(betSlipState: IBetslipState): boolean {
        return (
            (betSlipState.base.displayMode === BetslipDisplayMode.Tabbed && betSlipState.types.base.currentSelectedType === BetslipType.Teaser) ||
            (betSlipState.base.displayMode === BetslipDisplayMode.Linear && betSlipState.types.base.linearTypes[BetslipType.Teaser])
        );
    }

    updateRequest(request: PlaceBetRequest, betSlipState: IBetslipState, slips: ISlip[], betPicks?: IBetPicks | undefined): void {
        const teaserInd = slips.findIndex((s) => s.slipId === getTeaserSlipId());
        if (teaserInd > -1) {
            request.betSlips[teaserInd].betGroups = [this.getTeaserData(betSlipState, request.betSlips[teaserInd].bets)];
        }
    }

    private getTeaserData(state: IBetslipState, bets: Bet[]): BetGroup {
        return {
            betGroupType: BetGroupType.Teaser,
            bets: bets.map((t) => t.index),
            index: 0,
            oddsFormat: OddsOperations.convertToBposOddsFormat(this.userOddsFormatSettingsService.oddsFormat),
            teaserDetails: {
                teasedOriginalPickIds: [],
                teasedPoints: state.types.teaserBet.selectedPoints,
                teaserPriceVersionId: state.types.teaserBet.priceVersionId,
            },
            userExpectedOdds: this.convertToBposOddsV1(state.types.teaserBet.teaserPrice!),
        };
    }

    private convertToBposOddsV1(odds: Odds): BPosOdds {
        return {
            american: odds.moneyline,
            european: odds.decimals,
            british: odds.fractional,
        };
    }
}
